/* global debounce */

// ********************************************
// 1.0 - READY
// ********************************************

const cDirection = -1; // 1 = normal, -1 = alternate
const cRatio = 50;
const bodyElem = document.querySelector('body');
const elGyroEffect = document.querySelector('.gyro-effect');

if (elGyroEffect) {
  const elGyroCanvas = elGyroEffect.querySelector('.gyro-canvas');

  // ********************************************
  // 2.0 - GYRO
  // ********************************************

  const isElementXPercentInViewport = function (el) {
    const percentVisible = 0.1;
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    return !(
      Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100) < percentVisible
      || Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
    );
  };

  const gyroOnScreen = () => isElementXPercentInViewport(elGyroEffect);

  const gyroDesktop = () => {
    document.addEventListener('mousemove', (e) => {
      // check if Gyro Element is on screen and run calcs
      if (gyroOnScreen()) {
        const offsetX = 80;
        const offsetY = 40;

        // eslint-disable-next-line max-len
        const posX = (cDirection * ((e.clientX - elGyroCanvas.offsetWidth / 2) / cRatio) + offsetX).toFixed(2);
        // eslint-disable-next-line max-len
        const posY = cDirection * ((e.clientY - elGyroCanvas.offsetHeight / 2 + offsetY) / cRatio).toFixed(2);
        bodyElem.style.setProperty('--x', `${posX}px`);
        bodyElem.style.setProperty('--y', `${posY}px`);
        // bodyElem.style.setProperty('--z', posY + posY);
      }
    });
  };

  const gyroWatcher = () => {
    const gyroWatcherDebounce = debounce(() => {
      gyroOnScreen();
    }, 50);
    window.addEventListener('load', gyroWatcherDebounce);
    window.addEventListener('resize', gyroWatcherDebounce);
    window.addEventListener('scroll', gyroWatcherDebounce);
  };

  // ********************************************
  // 3.0 - LOAD
  // ********************************************

  window.addEventListener('load', () => {
    gyroDesktop();
    gyroWatcher();
    window.dispatchEvent(new Event('resize')); // Force resize to fix Squarespace height calculation after gyro is loaded
  });
}
